"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomizeIcon32 = void 0;
var react_1 = __importStar(require("react"));
var uniqueId_1 = __importDefault(require("lodash/uniqueId"));
var build_svg_icon_1 = require("../../build-svg-icon");
exports.CustomizeIcon32 = (0, build_svg_icon_1.buildSvgIcon)(function () {
    var _a = __read((0, react_1.useState)((0, uniqueId_1.default)('customize-icon32')), 1), uniqueId = _a[0];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("g", { clipPath: "url(#".concat(uniqueId, ")") },
            react_1.default.createElement("path", { d: "M11.8683 7.45992C12.0963 6.97018 12.7926 6.97018 13.0206 7.45992L15.5556 12.9064C16.1621 14.2093 17.1923 15.2682 18.4781 15.9102L23.7502 18.5425C24.219 18.7766 24.219 19.4455 23.7502 19.6796L18.4781 22.3119C17.1923 22.9539 16.1621 24.0128 15.5556 25.3157L13.0206 30.7622C12.7926 31.2519 12.0963 31.2519 11.8683 30.7622L9.33329 25.3157C8.72683 24.0128 7.69661 22.9539 6.4108 22.3119L1.13869 19.6796C0.669892 19.4455 0.669892 18.7766 1.13869 18.5425L6.41079 15.9102C7.69661 15.2682 8.72683 14.2093 9.33329 12.9064L11.8683 7.45992Z", fill: "currentColor" }),
            react_1.default.createElement("path", { d: "M25.4743 0.674655C25.5921 0.412945 25.9637 0.412944 26.0814 0.674655L27.3254 3.43939C27.6339 4.12501 28.1654 4.68601 28.8334 5.03102L31.4275 6.37093C31.6677 6.49496 31.6677 6.83837 31.4275 6.96241L28.8334 8.30231C28.1654 8.64733 27.6339 9.20832 27.3254 9.89395L26.0814 12.6587C25.9637 12.9204 25.5921 12.9204 25.4743 12.6587L24.2304 9.89395C23.9219 9.20832 23.3904 8.64733 22.7224 8.30231L20.1282 6.96241C19.8881 6.83837 19.8881 6.49496 20.1282 6.37093L22.7224 5.03102C23.3904 4.68601 23.9219 4.12501 24.2304 3.43939L25.4743 0.674655Z", fill: "currentColor" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: uniqueId },
                react_1.default.createElement("rect", { width: "32", height: "32", fill: "currentColor" })))));
}, 'CustomizeIcon32', { viewBox: '0 0 32 32' });
exports.default = exports.CustomizeIcon32;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ3VzdG9taXplSWNvbjMyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vZGVzaWduLXN5c3RlbS1pY29ucy91aS1pY29ucy8zMi9DdXN0b21pemVJY29uMzIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDZDQUF3QztBQUN4Qyw2REFBd0M7QUFDeEMsdURBQW9EO0FBRXZDLFFBQUEsZUFBZSxHQUFHLElBQUEsNkJBQVksRUFDekM7SUFDUSxJQUFBLEtBQUEsT0FBYSxJQUFBLGdCQUFRLEVBQUMsSUFBQSxrQkFBUyxFQUFDLGtCQUFrQixDQUFDLENBQUMsSUFBQSxFQUFuRCxRQUFRLFFBQTJDLENBQUM7SUFDM0QsT0FBTyxDQUNMO1FBQ0UscUNBQUcsUUFBUSxFQUFFLGVBQVEsUUFBUSxNQUFHO1lBQzlCLHdDQUNFLENBQUMsRUFBQyxraEJBQWtoQixFQUNwaEIsSUFBSSxFQUFDLGNBQWMsR0FDbkI7WUFDRix3Q0FDRSxDQUFDLEVBQUMsd2hCQUF3aEIsRUFDMWhCLElBQUksRUFBQyxjQUFjLEdBQ25CLENBQ0E7UUFDSjtZQUNFLDRDQUFVLEVBQUUsRUFBRSxRQUFRO2dCQUNwQix3Q0FBTSxLQUFLLEVBQUMsSUFBSSxFQUFDLE1BQU0sRUFBQyxJQUFJLEVBQUMsSUFBSSxFQUFDLGNBQWMsR0FBRyxDQUMxQyxDQUNOLENBQ04sQ0FDSixDQUFDO0FBQ0osQ0FBQyxFQUNELGlCQUFpQixFQUNqQixFQUFFLE9BQU8sRUFBRSxXQUFXLEVBQUUsQ0FDekIsQ0FBQztBQUVGLGtCQUFlLHVCQUFlLENBQUMifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/design-system-icons/ui-icons/32/CustomizeIcon32.js
// module id = 5147
// module chunks = 25